module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#comment",
      toString: function () {
        return this.url;
      }
    }